import { getStageRewardPools } from "../../content/index.js";
import { createLcg } from "../rng/lcg.js";
import { shuffle } from "../rng/shuffle.js";
import type { CardId } from "../types/index.js";

export type PickRewardsInput = {
  size: "small" | "medium" | "large";
  rngState: number;
  stageId?: string;
};

export type PickRewardsResult = {
  cardIds: CardId[];
  rngState: number;
};

export function pickRewards(input: PickRewardsInput): PickRewardsResult {
  const pool = getStageRewardPools(input.stageId)[input.size];
  const rng = createLcg(input.rngState);
  const combined = shuffle([...pool.workers, ...pool.actions], rng);
  return {
    cardIds: combined.slice(0, 3),
    rngState: rng.state,
  };
}
